<template>
    <div class="container-lineChart_v">
        <v-chart :options="option"  ref="ff"  autoresize/>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'

import 'echarts/lib/chart/line'

import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'


export default {
  name: 'lineChart_v',
  props: {  
    title:{
      type: String,
      default: ""
    },
    lineColor:{
      type:String,
      default:"#16CEB9"
    },
    type:{
      type:String,
      default:"consumption_age"
    }
  },
  data () {  
    return {     
       option:{},
       xdata:[],
       data:[]
    }
  },
  methods: {
 
  },
  mounted () {
   var that=this
   if(that.type=="consumption_age"){
     that.xdata=[]
     that.data=[]
   }
   else{
     that.xdata=["0-300","300-500","500-700","700-900","900-1100","1100+"]
     that.data=[]
   }
 this.ff=this.$refs.ff,
    this.option = {
      
       grid: {
            top:'10%',
            left: '8%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
             axisLabel: {             
                color:'#FFFFFF',
                rotate:40,
                fontSize:12,
                interval:0
             },
           
            axisTick:{show:false},
            type: 'category',            
            data: that.xdata,
             splitLine:{ 
                show: true,
                    lineStyle: {
                      color: '#323645',
                      type: 'solid',
                      width:1,
                      opacity:0.5
                    },
              },          
        },
        yAxis: {
         
           axisTick:{show:false},
              splitLine:{ show:false},
              axisLabel: {     
                color:'#FFFFFF'   
              },
              
              type: 'value'     
        },     
        tooltip :{
					formatter:function(params,index){
        
						var result = ''
            
             
          
            params.forEach(function (item) {
              
              if(that.type=="consumption_age"){
                result=params[0].name+'月' + "</br>"
                      
                  result += "年龄:"+ (item.data=='0.1'?'0':item.data) + "</br>"
              }
              else {
           result=params[0].name + "</br>"
                   result += "购买人数:"+ item.data + "</br>"
              }
            })
          
						return result
					},
					textStyle:{
						// fontSize:18
					},
          trigger: "axis",
    axisPointer: {
      type: "none",
   
    }
        },  
        animation:false,
        series: [{
            data: that.data,
            type: 'line',
            symbol: "circle", 
            symbolSize: 7,             
            itemStyle : { 
                 emphasis: {              
                      borderWidth:5,
                      borderColor: "#fff"               
                 },
                normal : {                  
                  color:this.lineColor, //改变折线点的颜色
                  lineStyle:{ 
                    color:this.lineColor //改变折线颜色
                  },                 
                } 
            },
        }]
    };
  },
  components: {
      'v-chart': ECharts
  }  
}
</script>

<style lang="scss">

        .container-lineChart_v{
           height: 100%;
            width: 100%;
        .echarts{
            width: 100%;
            height: 100%;
        }
    }
</style>